import { Component } from '@angular/core';
import { ReportResponseService } from '../../../services/report_response.service';

@Component({
  selector: 'app-report-totalizer',
  templateUrl: './report-totalizer.component.html',
  styleUrl: './report-totalizer.component.scss'
})
export class ReportTotalizerComponent {
  total:number = 0;
  totalDiscounts:number = 0;
  totalToPay:number = 0;
  calculated:boolean = true;
  constructor(
    private reportResponseService:ReportResponseService,
  ) {
  }

  ngOnInit() {
    this.reportResponseService.selectedReportResponseId$.subscribe(reportResponseId => {
      if (reportResponseId) {

        this.reportResponseService.getTotalsReport(reportResponseId).subscribe(totals => {
          if (totals) {
            this.total = totals.total;
            this.totalDiscounts = totals.totalDiscounts;
            this.totalToPay=totals.totalNet;
          }else{
            this.calculated = false;
          }
        });
      }
    })
  }


}
